"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookingcomApi = void 0;
const handlers_1 = require("../handlers");
exports.bookingcomApi = (http, prefix = '/bookingcom') => ({
    getListing(id) {
        return http.get(`${prefix}/listing/property/${id}`);
    },
    propertyRetrieve(id) {
        return http.get(`${prefix}/property/${id}/retrieve`)
            .catch(handlers_1._404({}))
            .then((resp) => resp);
    },
    propertyVerify(id) {
        return http.get(`${prefix}/property/${id}/verify`)
            .catch(handlers_1._404({}))
            .then((resp) => resp);
    },
    propertyDelist(id) {
        return http.post(`${prefix}/property/${id}/delist`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    propertyList(id) {
        return http.post(`${prefix}/property/${id}/list`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    propertyOpen(id) {
        return http.post(`${prefix}/property/${id}/open`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncImagesComplete(id) {
        return http.post(`${prefix}/sync/${id}/images_complete`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncKeyCollection(id) {
        return http.post(`${prefix}/sync/${id}/key_collection`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncAvailability(id) {
        return http.post(`${prefix}/sync/${id}/availability`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncImagesVerification(id) {
        return http.post(`${prefix}/sync/${id}/verification`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncHouseRules(id) {
        return http.post(`${prefix}/sync/${id}/house_rules`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncRatePlan(id) {
        return http.post(`${prefix}/sync/${id}/rate_plan`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncProperty(id) {
        return http.post(`${prefix}/sync/${id}/property`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncProduct(id) {
        return http.post(`${prefix}/sync/${id}/product`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncImages(id) {
        return http.post(`${prefix}/sync/${id}/images`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncRates(id, recreate = false) {
        return http.post(`${prefix}/sync/${id}/rates?recreate=${recreate}`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    },
    syncRoom(id) {
        return http.post(`${prefix}/sync/${id}/room`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.listing);
    }
});
//# sourceMappingURL=index.js.map